import {
  CheckCircleOutlined,
  EditOutlined,
  FundOutlined,
  StopOutlined,
} from "@ant-design/icons";
import { PageHeader, Popconfirm, message, Tooltip } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  cuentaMask,
  TableItem,
  ButtonItem,
  SegmentedItem,
} from "../../../Components/Items";
import AgregarProyecto from "../Proyectos/AgregarProyecto/AgregarProyecto";
import EditarProyecto from "../Proyectos/EditarProyecto/EditarProyecto";
import IconCartCrane from "../../../Icons/IconCartCrane";

class Vehiculos extends Component {
  state = {
    todasProyectos: [],
    modalAgregarProyecto: false,
    modalEditarProyecto: false,
    modalEditarProyectoId: null,
    loading: false,
    valor: 1,
  };
  componentDidMount() {
    this.consultarProyectos(this.state.valor);
  }

  consultarProyectos(valor) {
    this.setState({ loading: true });
    axios
      .post(
        "proyectos/selectTodosProyectos",
        { empresaId: this.props.empresaId, valor: valor, vehiculos: true },
        {
          headers: this.props.headersToken,
        },
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.status === 404) {
          this.setState({ todasProyectos: [] });
        } else {
          this.setState({
            todasProyectos: res.data.map((value) => {
              return {
                ...value,
                accion: {
                  _id: value._id,
                  estado: value.estado,
                  consignacion: value.consignacion,
                },
              };
            }),
          });
        }
      });
  }

  deshabilitarProyecto(value) {
    axios
      .post(
        "proyectos/deshabilitarProyecto",
        { proyectoId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Proyecto deshabilitado");
        } else {
          message.error("Sucedio un error y no se pudo deshabilitar");
        }
        this.consultarProyectos();
      });
  }
  habilitarProyecto(value) {
    axios
      .post(
        "proyectos/habilitarProyecto",
        { proyectoId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Proyecto habilitado");
        } else {
          message.error("Sucedio un error y no se pudo habilitar");
        }
        this.consultarProyectos();
      });
  }

  abrirAgregarProyecto() {
    this.setState({ modalAgregarProyecto: true });
  }
  cerrarAgregarProyecto() {
    this.setState({ modalAgregarProyecto: false });
    this.consultarProyectos(this.state.valor);
  }
  abrirEditarProyecto(id) {
    this.setState({ modalEditarProyecto: true, modalEditarProyectoId: id });
  }
  cerrarEditarProyecto() {
    this.setState({ modalEditarProyecto: false });
    this.consultarProyectos(this.state.valor);
  }
  render() {
    const columns = [
      {
        title: "Nombre",
        dataIndex: "nombre",
        key: "nombre",
        sorter: (a, b) => {
          if (a.nombre < b.nombre) {
            return -1;
          }
          if (a.nombre > b.nombre) {
            return 1;
          }
          return 0;
        },
        buscar: "nombre",
      },
      {
        title: "Descripción",
        dataIndex: "descripcion",
        key: "descripcion",
        sorter: (a, b) => {
          if (a.descripcion < b.descripcion) {
            return -1;
          }
          if (a.descripcion > b.descripcion) {
            return 1;
          }
          return 0;
        },
        buscar: "descripcion",
      },
      {
        title: "Tipo de Unidad",
        dataIndex: "tipoDeUnidad",
        key: "tipoDeUnidad",
        sorter: (a, b) => {
          if (a.tipoDeUnidad < b.tipoDeUnidad) {
            return -1;
          }
          if (a.tipoDeUnidad > b.tipoDeUnidad) {
            return 1;
          }
          return 0;
        },
        render: (value) => {
          if (value === 1) {
            return "Fisico";
          }
          if (value === 2) {
            return "Movil";
          }
        },
      },
      {
        title: "Unidad de negocio",
        dataIndex: "unidaddenegocio",
        key: "unidaddenegocio",
        render: (value) => {
          return (
            cuentaMask(
              value.nivel1 +
                value.nivel2 +
                value.nivel3 +
                value.nivel4 +
                value.nivel5,
            ) +
            " - " +
            value.nombre
          );
        },
      },
      {
        title: "Acción",
        dataIndex: "accion",
        key: "accion",
        align: "center",
        onHeaderCell: () => ({
          style: { textAlign: "center", padding: "4px" },
        }),
        onCell: () => ({
          className: "acciones-sin-hover",
          style: { textAlign: "center", padding: "4px" },
        }),
        render: (value, index) => {
          let buttons = [];

          // Botón Editar
          if (this.props.permisoEditarProyecto && !value.consignacion) {
            buttons.push(
              <Tooltip
                title="Editar Proyecto"
                placement="top"
                overlayInnerStyle={{
                  fontSize: "10px",
                  padding: "1px 5px",
                  minHeight: "auto",
                }}
              >
                <ButtonItem
                  key={`editar-${index}`}
                  type="default"
                  size="small"
                  cyan
                  icon={<EditOutlined />}
                  onClick={() => this.abrirEditarProyecto(value._id)}
                ></ButtonItem>
              </Tooltip>,
            );
          }

          // Botón Consumos de combustible
          if (this.props.permisoRendimientoVehiculos) {
            buttons.push(
              <Tooltip
                key={`consumo-${value._id}`}
                title="Ver consumos de combustible"
                placement="top"
                overlayInnerStyle={{
                  fontSize: "10px",
                  padding: "1px 5px",
                  minHeight: "auto",
                }}
              >
                <ButtonItem
                  type="default"
                  size="small"
                  azul
                  icon={<FundOutlined />}
                  onClick={() =>
                    this.props.history.push("/panel/consumoCombustible", {
                      id: value._id,
                      nombre: index.nombre,
                    })
                  }
                ></ButtonItem>
              </Tooltip>,
            );
          }

          // Botón Habilitar/Deshabilitar
          if (this.props.permisoDeshabilitarProyecto && !value.consignacion) {
            if (value.estado === 1) {
              buttons.push(
                <Popconfirm
                  key={`deshabilitar-${index}`}
                  title="Seguro que quieres deshabilitar este proyecto"
                  onConfirm={() => this.deshabilitarProyecto(value._id)}
                  okText="Si"
                  cancelText="No"
                >
                  <Tooltip
                    title="Deshabilitar"
                    placement="top"
                    overlayInnerStyle={{
                      fontSize: "10px",
                      padding: "1px 5px",
                      minHeight: "auto",
                    }}
                  >
                    <ButtonItem
                      type="default"
                      size="small"
                      lima
                      icon={<CheckCircleOutlined />}
                    ></ButtonItem>
                  </Tooltip>
                </Popconfirm>,
              );
            } else {
              buttons.push(
                <Popconfirm
                  key={`habilitar-${index}`}
                  title="Seguro que quieres habilitar este proyecto"
                  onConfirm={() => this.habilitarProyecto(value._id)}
                  okText="Si"
                  cancelText="No"
                >
                  <Tooltip
                    title="Habilitar"
                    placement="top"
                    overlayInnerStyle={{
                      fontSize: "10px",
                      padding: "1px 5px",
                      minHeight: "auto",
                    }}
                  >
                    <ButtonItem
                      type="default"
                      size="small"
                      rojo
                      icon={<StopOutlined />}
                    ></ButtonItem>
                  </Tooltip>
                </Popconfirm>,
              );
            }
          }

          return <div className="acciones-container">{buttons}</div>;
        },
      },
    ];
    return (
      <>
        <PageHeader
          title={<span>
            <IconCartCrane size={22} /> Vehículos
          </span>}
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <>
              {window.innerWidth > 1000 && (
                <SegmentedItem
                  options={[
                    { label: "Activo", value: 1 },
                    { label: "Deshabilitado", value: 2 },
                    { label: "Todos", value: 3 },
                  ]}
                  onChange={(value) => {
                    this.consultarProyectos(value);
                    this.setState({ valor: value });
                  }}
                  value={this.state.valor}
                />
              )}
              {this.props.permisoAgregarProyecto && (
                <ButtonItem
                  type="primary"
                  key="agregarProyecto"
                  olivo
                  onClick={this.abrirAgregarProyecto.bind(this)}
                   className="botonAgregar"
                >
                  Agregar Vehículo
                </ButtonItem>
              )}
            </>
          }
        />
        <TableItem
          loading={this.state.loading}
          size="small"
          dataSource={this.state.todasProyectos}
          columns={columns}
        />
        {this.props.permisoAgregarProyecto && (
          <AgregarProyecto
            visible={this.state.modalAgregarProyecto}
            cerrarAgregarProyecto={this.cerrarAgregarProyecto.bind(this)}
            vehiculo = {true}
          />
        )}
        {this.props.permisoEditarProyecto && (
          <EditarProyecto
            visible={this.state.modalEditarProyecto}
            id={this.state.modalEditarProyectoId}
            cerrarEditarProyecto={this.cerrarEditarProyecto.bind(this)}
            vehiculo = {true}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    permisoAgregarProyecto:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "615ced77f30e81b54183cfc9",
      )?.activado,
    permisoEditarProyecto:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "615ceda1f30e81b54183cfca",
      )?.activado,
    permisoDeshabilitarProyecto:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "615cedeff30e81b54183cfcb",
      )?.activado,
    permisoRendimientoVehiculos:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a430b6a101fa825078813bc",
      )?.activado,
  };
};

export default connect(mapStateToProps)(Vehiculos);
